import { napakaApi } from './napaka';

/**
 * PDF s strežnika (izdela ga hera-server): prenese ga z dostopnim žetonom in odpre v
 * novem zavihku (na telefonu ga brskalnik ponudi v pregledovalniku). Ime datoteke iz glave Content-Disposition.
 */
export async function odpriPdf(klic: Promise<{ data?: unknown; error?: unknown; response: Response }>): Promise<void> {
  // zavihek odpremo takoj (ob kliku), sicer ga brskalnik po čakanju na strežnik blokira kot pojavno okno
  const zavihek = window.open('', '_blank');
  try {
    const { data, error, response } = await klic;
    if (!response.ok) {
      throw napakaApi(error, response.status);
    }
    const blob = data instanceof Blob ? data : new Blob([data as BlobPart], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    if (zavihek) {
      zavihek.location.href = url;
    } else {
      const a = document.createElement('a');
      a.href = url;
      a.download = imeDatoteke(response) ?? 'dokument.pdf';
      a.click();
    }
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  } catch (e) {
    zavihek?.close();
    throw e;
  }
}

/**
 * Datoteka s strežnika (npr. eSLOG XML) se shrani kot prenos z imenom iz glave Content-Disposition (ali {@code privzeto}).
 */
export async function prenesiDatoteko(
  klic: Promise<{ data?: unknown; error?: unknown; response: Response }>,
  privzeto: string,
): Promise<void> {
  const { data, error, response } = await klic;
  if (!response.ok) {
    throw napakaApi(error, response.status);
  }
  const blob = data instanceof Blob ? data : new Blob([data as BlobPart]);
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = imeDatoteke(response) ?? privzeto;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

function imeDatoteke(r: Response): string | undefined {
  const cd = r.headers.get('Content-Disposition') ?? '';
  const utf = /filename\*=UTF-8''([^;]+)/i.exec(cd);
  if (utf?.[1]) {
    return decodeURIComponent(utf[1]);
  }
  return /filename="?([^";]+)"?/i.exec(cd)?.[1];
}
